import React from 'react'
import Landing from './Landing'
import Footer from './Footer'
import PageToreister from './PageToreister'
import Categories from './Categories'

function HomePage() {
    return (
        <>
            <Landing />
            <Categories />
            <PageToreister />
            <Footer />
        </>
    )
}

export default HomePage